import React from "react";
import Cell from "../Cell";
import ModulePropertyDialog from "../ModulePropertyDialog";
import SectionPropertyDialog from "../SectionPropertyDialog";
import { HINGE_NAMES } from "../../../constants";
import { isMobileOnly } from "react-device-detect";

const HingeCell = ({
  type,
  rowId,
  tempId,
  sectionId,
  isFiller = false,
  errorMessage,
  tableManager,
  propertyList = [],
  onContextMenu,
  viewMode,
  reviewColumnColorMap,
  onValueChange,
  dialogProps,
  setCurrentTab,
}) => {
  const getCellBackgroundColor = (column, value) => {
    if (!reviewColumnColorMap) return null;

    // Always use column-specific key to match the color map format
    const normalizedValue = value || "";
    const mapKey = `${column}__${normalizedValue}`;

    return reviewColumnColorMap[mapKey] || null;
  };

  const property = propertyList.find((prop) => prop.identifier === "hinge");

  const selectedOption =
    property && property.options.find((opt) => opt.selected);

  let value = "";

  if (property) {
    if (viewMode === "review" && type === "module")
      value = HINGE_NAMES[selectedOption.prop_option_identifier];
    else if (
      viewMode === "spec" &&
      (property.is_overridden_v2 || type === "section")
    )
      value = HINGE_NAMES[selectedOption.prop_option_identifier];
  }

  if (viewMode === "review" && type === "module")
    onValueChange(rowId, "review_hinge", (value || "").trim());

  const backgroundColor =
    viewMode === "review"
      ? getCellBackgroundColor("review_hinge", value)
      : undefined;

  return (
    <Cell
      rowId={rowId}
      sectionId={sectionId}
      rowType={type}
      column="hinge"
      className="flex-grow-0 flex-shrink-0"
      customStyles={{
        width: isMobileOnly ? "15%" : "120px",
        backgroundColor: backgroundColor || undefined,
      }}
      tableManager={tableManager}
    >
      <div className="fs-10px">{value}</div>

      {tableManager.isActive(type, rowId, "hinge") &&
        (type === "module" ? (
          <ModulePropertyDialog {...dialogProps} properties={[property]} setCurrentTab={setCurrentTab} />
        ) : (
          <SectionPropertyDialog {...dialogProps} properties={[property]} setCurrentTab={setCurrentTab} />
        ))}
    </Cell>
  );
};

export default HingeCell;
